module.exports = __webpack_public_path__ + "img/pa.810983fa.svg";